export const REQUEST_DONATION_GROUP_LIST = 'REQUEST_DONATION_GROUP_LIST';
export const REQUEST_DONATION_GROUP = 'REQUEST_DONATION_GROUP'